module.exports = __webpack_public_path__ + "img/expand.af27d685.png";